import React from "react";
import { User, MapPin, Phone, Mail, BadgeInfo } from "lucide-react";

export default function Impressum() {
  return (
    <main className="legal-page flex flex-col items-center min-h-screen py-12 px-4 bg-gradient-to-br from-black via-[#181818] to-[#222]">
      <div className="max-w-xl w-full bg-[#181818] rounded-2xl shadow-2xl p-10 border border-[#FFD700]/40 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#FFD700]/60 via-transparent to-[#FFD700]/60 rounded-t-2xl" />
        <div className="flex flex-col items-center mb-8">
          <span className="bg-[#FFD700]/20 p-4 rounded-full mb-4">
            <BadgeInfo size={40} className="text-[#FFD700]" />
          </span>
          <h1 className="text-4xl font-extrabold text-[#FFD700] mb-2 text-center drop-shadow-lg tracking-wide">Impressum</h1>
          <div className="h-1 w-16 bg-[#FFD700]/60 rounded-full mb-2" />
        </div>
        <div className="space-y-6 text-white text-lg font-light">
          <div className="flex items-center gap-2">
            <User className="text-[#FFD700]" size={22} />
            <span className="font-semibold text-[#FFD700]">Rwan Cut</span>
          </div>
          <div className="flex items-center gap-2">
            <User className="text-[#FFD700]" size={20} />
            <span className="font-semibold">Inhaber:</span>
            <span>Rwan Mamo</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="text-[#FFD700]" size={20} />
            <span>
              <span className="font-semibold">Adresse:</span><br />
              Hellweg 15<br />
              44787 Bochum<br />
              Deutschland
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Phone className="text-[#FFD700]" size={20} />
            <span className="font-semibold">Telefon:</span>
            <a href="tel:+491726060056" className="text-[#FFD700] hover:underline ml-1">+49 172 6060056</a>
          </div>
          <div className="flex items-center gap-2">
            <Mail className="text-[#FFD700]" size={20} />
            <span className="font-semibold">E-Mail:</span>
            <a href="mailto:rwanmaamo@gmail.com" className="text-[#FFD700] hover:underline ml-1">rwanmaamo@gmail.com</a>
          </div>
          <div className="border-t border-[#FFD700]/30 pt-4">
            <span className="font-semibold">Umsatzsteuer</span><br />
            Gemäß §19 UStG wird keine Umsatzsteuer erhoben
            (Kleinunternehmerregelung).

          </div>
          <div className="border-t border-[#FFD700]/30 pt-4">
            <span className="font-semibold">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</span><br />
            Mamo Rwan (Anschrift wie oben)
          </div>
        </div>
      </div>
    </main>
  );
}